import { PipeTransform, Pipe } from "@angular/core";
import { IconProp } from "@fortawesome/fontawesome-svg-core";

@Pipe({
  name: "yesNoIcon"
})
export class YesNoIconPipe implements PipeTransform {
  transform(value: boolean): IconProp {
    return value ? "check" : "close";
  }
}
